import Tutorial, { ChapterType, ExerciseScene } from 'Types/ExerciseData';
import { AddEventsAndMergeTimestamps, Timestamps } from 'Utils/ChaptersToTimestamps';
import { Exercise, NoteSequenceExercise } from 'Utils/TutorialConfigHelper';
import timestamps from './level6.json';

// This is still using the old JSON way of defining levels
const Level6: Tutorial = {
  end: '1:52',
  level: 6,
  videoUrl: 'level-6.mp4',
  sections: [
    {
      chapters: [
        {
          title: 'Reviewing Time Signatures',
          start: '0:0',
          data: [ChapterType.Lecture],
        },
        {
          title: '3/4 Time',
          start: '0:32',
          data: [ChapterType.Lecture],
        },
        {
          title: 'Dotted Half Notes',
          start: '0:45',
          data: [ChapterType.Lecture],
        },
        Exercise(
          'Dotted Half Notes',
          '1:10',
          NoteSequenceExercise({
            tempo: 60,
            objectives: [
              {
                text: 'Play these dotted half notes, using any key.',
                notes: [
                  {
                    length: 'half-dotted',
                  },
                  {
                    length: 'half-dotted',
                  },
                ],
              },
            ],
          }),
          [],
        ),
        {
          title: 'Playing on the Staff',
          start: '1:20',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.StaffExercise,
                {
                  objectives: [{}, {}],
                },
              ],
              events: [],
            },
          ],
        },
      ],
    },
    {
      chapters: [
        {
          title: 'Combining Rhythms',
          start: '1:31',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.StaffExercise,
                {
                  objectives: [{}, {}],
                },
              ],
              events: [],
            },
          ],
        },
      ],
    },
  ],
};
export default AddEventsAndMergeTimestamps(timestamps as Timestamps, Level6);
